module.exports = __webpack_public_path__ + "static/media/1.45101a8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16467/1.jpg
// module id = 565
// module chunks = 0